import { VocabularyTestResultWord } from 'app/types';

const DURATION_UNIT_MAP: Record<string, string> = {
  day: 'дн',
  days: 'дн',
  hour: 'год',
  hours: 'год',
  minute: 'хв',
  minutes: 'хв',
  second: 'с',
  seconds: 'с',
};

/**
 * Compacts the BE's prose duration ("14 minutes, 20 seconds") into a short
 * inline form ("14 хв 20 с"). BE format: comma-separated "<n> <unit>"
 * segments, largest unit first, zero-valued units omitted (except when the
 * whole duration is zero, where it sends "0 seconds").
 */
export const formatTestDuration = (raw: string): string => {
  if (!raw) return '';
  return raw
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const [value, unit] = part.split(' ');
      return `${value} ${DURATION_UNIT_MAP[unit] || unit}`;
    })
    .join(' ');
};

export interface ResultCategoryBuckets {
  learned: VocabularyTestResultWord[];
  active: VocabularyTestResultWord[];
  repeat: VocabularyTestResultWord[];
}

/**
 * `learnedWords` from the BE mixes LEARNED and ACTIVE words together
 * (both have isLearned=true) — split them here by isActiveSpeech so the
 * 3 result tabs are mutually exclusive, mirroring the dictionary-wide
 * statusOf() convention (learned := isLearned && !isActiveSpeech).
 */
export const buildResultCategories = (
  learnedWords: VocabularyTestResultWord[] | undefined,
  repeatWords: VocabularyTestResultWord[] | undefined,
): ResultCategoryBuckets => {
  const words = learnedWords || [];
  return {
    learned: words.filter((w) => !w.isActiveSpeech),
    active: words.filter((w) => w.isActiveSpeech),
    repeat: repeatWords || [],
  };
};

export const filterWordsByQuery = (
  words: VocabularyTestResultWord[],
  query: string,
): VocabularyTestResultWord[] => {
  const q = query.trim().toLowerCase();
  if (!q) return words;
  return words.filter(
    (w) =>
      w.word.toLowerCase().includes(q) ||
      (w.translation || '').toLowerCase().includes(q),
  );
};
